import CompanyFormStepUserSource from '@/components/create-startups/CompanyFormStepUserSource'

import InvestorFormStepEligibility from './InvestorFormStepEligibility'
import InvestorFormStepSettingTheScene from './InvestorFormStepSettingTheScene'
import InvestorFormStepBasics from './InvestorFormStepBasics'
import InvestorFormStepStage from './InvestorFormStepStage'
import InvestorFormStepAbout from './InvestorFormStepAbout'
import InvestorFormStepIndustry from './InvestorFormStepIndustry'
import InvestorFormStepMarket from './InvestorFormStepMarket'
import InvestorFormStepCountry from './InvestorFormStepCountry'
import InvestorFormStepKeyPeople from './InvestorFormStepKeyPeople'
import InvestorFormStepInvestments from './InvestorFormStepInvestments'
import InvestorFormStepImpact from './InvestorFormStepImpact'
import InvestorFormStepContact from './InvestorFormStepContact'
import InvestorFormStepReview from './InvestorFormStepReview'
import InvestorFormStepConfirmation from './InvestorFormStepConfirmation'
import InvestorFormStepManagers from './InvestorFormStepManagers'

export const STEP_ELIGIBILITY = 'eligibility'
export const STEP_USER_SOURCE = 'source'
export const STEP_SETTING_THE_SCENE = 'setting-the-scene'
export const STEP_BASICS = 'basics'
export const STEP_STAGE = 'stage'

export const STEP_ABOUT = 'about'
export const STEP_INDUSTRY = 'industry'
export const STEP_MARKET = 'market'
export const STEP_COUNTRY = 'country'
export const STEP_KEY_PEOPLE = 'key-people'
export const STEP_INVESTMENTS = 'investments'
export const STEP_IMPACT = 'impact'
export const STEP_CONTACT = 'contact'

export const STEP_MANAGERS = 'managers'

export const STEP_REVIEW = 'review'
export const STEP_CONFIRMATION = 'confirmation'

export const MODE_CREATE = 'create'
export const MODE_UPDATE = 'update'

export const steps = [
  {
    key: STEP_ELIGIBILITY,
    component: InvestorFormStepEligibility,
    hidden: true
  },
  {
    key: STEP_USER_SOURCE,
    component: CompanyFormStepUserSource,
    hidden: true
  },
  {
    key: STEP_SETTING_THE_SCENE,
    component: InvestorFormStepSettingTheScene,
    title: 'Setting the scene'
  },
  {
    key: STEP_COUNTRY,
    component: InvestorFormStepCountry,
    title: 'Country'
  },
  {
    key: STEP_IMPACT,
    component: InvestorFormStepImpact,
    title: 'Impact'
  },
  {
    key: STEP_BASICS,
    component: InvestorFormStepBasics,
    title: 'Basics'
  },
  {
    key: STEP_STAGE,
    component: InvestorFormStepStage,
    title: 'Stage'
  },
  {
    key: STEP_ABOUT,
    component: InvestorFormStepAbout,
    title: 'About',
    optional: true
  },
  {
    key: STEP_INDUSTRY,
    component: InvestorFormStepIndustry,
    title: 'Industry'
  },
  {
    key: STEP_MARKET,
    component: InvestorFormStepMarket,
    title: 'Market'
  },
  {
    key: STEP_KEY_PEOPLE,
    component: InvestorFormStepKeyPeople,
    title: 'Key people',
    optional: true
  },
  {
    key: STEP_INVESTMENTS,
    component: InvestorFormStepInvestments,
    title: 'Investments',
    optional: true
  },
  {
    key: STEP_CONTACT,
    component: InvestorFormStepContact,
    title: 'Contact',
    optional: true
  },
  {
    key: STEP_MANAGERS,
    component: InvestorFormStepManagers,
    title: 'Users',
    optional: true
  },
  {
    title: 'Submit',
    component: InvestorFormStepReview,
    key: STEP_REVIEW
  },
  {
    key: STEP_CONFIRMATION,
    component: InvestorFormStepConfirmation,
    hidden: true
  }
]
